import qs from 'qs'

export const queryPermanentWorkEntryBySlug = (options: QueryBySlugOptions) => {
  const searchKey = strapiGetI18nSlug(options.locale)

  const query = qs.stringify(
    {
      publicationState: options?.publicationState || 'live',
      locale: options?.locale || 'nl-NL',
      filters: {
        slugs: {
          [searchKey]: {
            $eq: options.slug
          }
        }
      },
      fields: ['title'],
      populate: {
        ...queryFragmentCollectionTypeDefault,
        ...queryFragmentBlocks,
        authors: true
      }
    },
    {
      encodeValuesOnly: true
    }
  )

  return `permanent-work-entries?${query}`
}
